import { BaseTabInterface } from 'base';
import { BaseCustomerOfferTabsEnum } from '../../inquiry/_enums/base-customer-offer-tabs.enum';

export const BaseCustomerOfferModalTabs: BaseTabInterface[] = [
  {
    id: BaseCustomerOfferTabsEnum.MaterData,
    title: 'masterData',
  },
  {
    id: BaseCustomerOfferTabsEnum.OfferInformation,
    title: 'inquiry.offerInformation',
  },
  {
    id: BaseCustomerOfferTabsEnum.Reviews,
    title: 'ratings',
  },
  {
    id: BaseCustomerOfferTabsEnum.WorkCouncil,
    title: 'workCouncil.label',
  },
  {
    id: BaseCustomerOfferTabsEnum.Documents,
    title: 'document.plural',
  },
];
